import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { isBiro, isBiroOnly } from "../utils/helper";
import FormFilter from "./Deviden/FormFilter";
import { toast } from "react-toastify";
import FormField from "./Deviden/FormField";
import Table from 'react-bootstrap/Table';
import API from "../utils/API";
import { createDeviden, updateDeviden } from "../api";
import { FormGroup, Input, Label } from "reactstrap";
import BarChartDeviden from "./Dashboard/BarChartDeviden";
import {
  DEVIDEN,
  PENYERTAAN_MODAL,
} from "../constants/chart";
import TableLegendDeviden from "./Dashboard/TableLegendDeviden";
import { Button } from 'semantic-ui-react'

const Deviden = () => {
  const [data, setData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [rawData, setRawData] = React.useState([]);
  const filter = useSelector((state) => state.filterReducer);
  const year = useSelector((state) => state.chartFilterDashboard.startYear);
  const month = useSelector((state) => state.chartFilterDashboard.startMonth);
  const perusahaanBumd = useSelector((state) => state.chartFilterDashboard.bumd);
  const perusahaanId = useSelector((state) => state.main.perusahaanFilter);
  const perusahaan = isBiro() ? perusahaanId : user.perusahaan.id;
  const [id, setId] = useState(null);
  const [penyertaanModal, setPenyertaanModal] = useState();
  const [deviden, setDeviden] = useState();
  const [catatan, setCatatan] = useState();
  const chartFilterDashboard = useSelector((state) => state.chartFilterDashboard);
  const chartchartFilterDashboard = useSelector(
    (state) => state.chartchartFilterDashboard
  );

  const fields = [
    {
      label: "Penyertaan Modal",
      value: penyertaanModal,
      type: "currency",
      onChange: (e) => setPenyertaanModal(e.floatValue),
    },
    {
      label: "Deviden",
      value: deviden,
      type: "currency",
      onChange: (e) => setDeviden(e.floatValue),
    },
  ];

  const res = [
    {
      label: "Keterangan",
      value: catatan,
      onChange: (value) => setCatatan(value),
    },
  ];

  const loadData = async () => {
    try {
      var url =
        `/penyertaan-modal-deviden?type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}&perusahaanId=${chartFilterDashboard.bumd}&startYear=${chartFilterDashboard.endYear}&endYear=${chartFilterDashboard.endYear}`;

      url = url.trim();
      const r = await API.get(url);
      const d = r.data;
      setData(d);
      setRawData(d);

    } catch (err) {
      toast.error(err.message, { position: toast.POSITION.BOTTOM_RIGHT });
    }
  };

  const getData = async () => {
    try {
      var url = `penyertaan-modal-deviden/filter?year=${chartFilterDashboard.startYear}&perusahaanId=${chartFilterDashboard.bumd}&month=${chartFilterDashboard.startMonth}`;

      url = url.trim();
      const r = await API.get(url);
      if (r.data.length > 0) {
        const data = r.data[0];
        setId(data.id);
        setPenyertaanModal(data.penyertaanModal);
        setDeviden(data.deviden);
        setCatatan(data.catatan);

      } else {
        setId(null);
        setPenyertaanModal(0);
        setDeviden(0);
        setCatatan("");
      }

    } catch (err) { }
  };

  const handleSubmit = async () => {
    try {
      let data = {
        penyertaanModal,
        deviden,
        catatan,
        year,
        month,
        perusahaan: {
          id: perusahaanBumd,
        },
      };
      if (id !== null) {
        data.id = id;
        await updateDeviden(data);
        toast.info("Data Berhasil Diubah");
      } else {
        await createDeviden(data);
        toast.success("Data Berhasil Disimpan");
      }
      await getData({ year, month, perusahaan, perusahaanBumd });

    } catch (err) { }
  };

  useEffect(() => {
    getData({ year, month, perusahaan, perusahaanBumd });
  }, [year, month, perusahaan, perusahaanBumd]);


  React.useEffect(() => {
    loadData();
  }, [
    chartFilterDashboard
  ]);



  return (
    <>
      <FormFilter title="Penyertaan Modal dan Deviden" />
      {isBiro() && (
        <div className="container mt-3">
          <div className="card container shadow-sm border-0">
            <div className="col-md-8 py-3">
              {fields.map((field, key) => (
                <Table bordereless hover>
                  <FormField
                    className="form-control text-right"
                    label={field.label}
                    key={key}
                    value={field.value}
                    onChange={field.onChange}
                    type="text"
                  />

                </Table>
              ))}

              {res.map((r, key) => (

                <div className="row mb-3">
                  <div className="col-md-5 d-flex align-items-center">
                    <Label>
                      {r.label}
                    </Label>
                  </div>
                  <div className="col-md-7">
                    <FormGroup>
                      <Input
                        className="form-control"
                        label={r.label}
                        type="textarea"
                        key={key}
                        value={r.value}
                        onChange={e => setCatatan(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                </div>
              ))}

              <div className="row">
                <div className="col d-flex justify-content-end align-items-center mt-md-0 mt-3">
                  <Button color="blue" onClick={handleSubmit}>
                    Simpan
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="container mt-3 py-3 border-0 h-100 d-flex justify-content-center align-items-center">
        <div className="card container shadow-sm border-0">
          <div className="container mt-3 py-3 border-0 h-100 d-flex justify-content-center align-items-center" >
            <BarChartDeviden type={PENYERTAAN_MODAL} />
            <BarChartDeviden type={DEVIDEN} />
          </div>
          <div className="row container mt-3 py-3 border-0 h-100 d-flex justify-content-center align-items-center " >
            <TableLegendDeviden type={DEVIDEN} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Deviden